import React from 'react';
import './style.scss';

export const GenericCheckbox = ({
  onCheckChange,
  id,
  checked,
  classNames = [''],
  caption,
}) => {
  const handleChange = e => {
    e.persist();
    onCheckChange(e);
  };

  return (
    <div className={`${['cv-generic-checkbox', ...classNames].join(' ')}`}>
      <input
        className="cv-generic-checkbox__check"
        type="checkbox"
        checked={checked}
        id={id}
        onChange={handleChange}
      />
      <label
        className={`cv-generic-checkbox__label ${checked ? 'checked' : ''}`}
        htmlFor={id}
      />
      <span className="cv-generic-checkbox__caption">{caption}</span>
    </div>
  );
};
